import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
// import { getCostCenterList } from "../../../services/Settings/dropdown"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const CostCenter = ({
  control,
  name,
  onSelectChange,
  target,
  placeholder,
  disabled,
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [fetchResponse, setFetchResponse] = useState([])

  const loadOptions = async () => {
    // const data = await getCostCenterList()
    const data = []
    setIsLoading(false)
    const response = data?.map(dta => {
      return {
        label: dta?.name && ucfirst(dta.name),
        value: dta.id,
        ...dta,
      }
    })

    setFetchResponse(response)
  }
  useEffect(() => {
    loadOptions()
  }, [])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({
          field: { onChange, ref, value },
          fieldState: { invalid },
        }) => {
          return (
            <Select
              options={fetchResponse}
              // placeholder={placeholder ? placeholder : "Select"}
              placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"} 
              </div>
            }
              isLoading={isLoading}
              inputRef={ref}
              invalid={invalid}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              isDisabled={disabled}
              value={value}
              classNamePrefix="react-select"
              className="elevate-dropdown"
              menuPortalTarget={document.querySelector(
                target ? target : ".modal"
              )}
            />
          )
        }}
      />
    </div>
  )
}

export default CostCenter
